import { render, staticRenderFns } from "./TrainConfigurationsLayout.vue?vue&type=template&id=c880e95a"
import script from "./TrainConfigurationsLayout.vue?vue&type=script&lang=js"
export * from "./TrainConfigurationsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports